import { Log } from "../events/CoreTelemetry.event";
import { isUTelLogHandler } from "../LoggingHelper";
import { makeBooleanDataField, makeStringDataField } from "@microsoft/oteljs";
/**
 * Emits Core Telemetry events through the shared log handler.
 */ export class CoreTelemetryLogger {
    log() {
        Log(this.logHandler);
    }
    setPersistentContext(context) {
        if (!isUTelLogHandler(this.logHandler)) {
            return;
        }
        this.logHandler.setCoreTelemetryPersistentDataField(makeStringDataField("Action.Workload", context.workload));
        this.logHandler.setCoreTelemetryPersistentDataField(makeStringDataField("Action.SubWorkload", context.subWorkload));
        this.setEntitlementContext(context);
    }
    setEntitlementContext(context) {
        if (!isUTelLogHandler(this.logHandler)) {
            return;
        }
        this.logHandler.setCoreTelemetryPersistentDataField(makeStringDataField("License.Type", context.licenseType));
        this.logHandler.setCoreTelemetryPersistentDataField(context.hasCopilotLicense === "" ? makeStringDataField("HasCopilotLicense", "") : makeBooleanDataField("HasCopilotLicense", context.hasCopilotLicense));
        this.logHandler.setCoreTelemetryPersistentDataField(context.isCopilotEnabled === "" ? makeStringDataField("IsCopilotEnabled", "") : makeBooleanDataField("IsCopilotEnabled", context.isCopilotEnabled));
    }
    constructor(logHandler){
        this.logHandler = logHandler;
    }
}
